'use client';

import { VisualEditing } from 'next-sanity';
import { useEffect } from 'react';
import { useLiveMode } from '@sanity/react-loader';
import { sanityClient } from '@/libs/sanity/sanity.client';
import { SanityConfig } from '@/configs/sanity.config';

const stegaClient = sanityClient.withConfig({ stega: true });

const LiveVisualEditing = () => {
	useLiveMode({ client: stegaClient });
	useEffect(() => {
		if (process.env.NEXT_PUBLIC_VERCEL_ENV !== 'preview' && window === parent) {
			location.href = SanityConfig.disableDraft;
		}
	}, []);

	return <VisualEditing />;
};

export default LiveVisualEditing;